import { gql } from '@apollo/client';

const deleteLetterTemplate = gql`
  mutation deleteLetterTemplate($id: Int!) {
    deleteLetterTemplate(id: $id)
  }
`;

export default deleteLetterTemplate;
